import React from "react";
import Button from "../Button/Button";
import "./1vs1.css";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import { GamePopupContext } from "../Context/GamePopupContext";
import { useContext } from "react";
import { motion } from "framer-motion";
import { useAuthContext } from "../../AuthContext";

function OnevsOne(props) {
  const { dispatchPopUp, gameState } = useContext(GamePopupContext);
  const [Amount, setAmount] = useState(null);
  const [Images, setImages] = useState(props.gameImage.stages);
  const { walletBalance } = useAuthContext();
  const handleGameClick = (id) => {
    let a = props.gameImage.stages.map((element, e) => {
      if (id === e) {
        return { ...element, isActive: true };
      } else {
        return { ...element, isActive: false };
      }
    });
    setImages(a);
  };
  useEffect(() => {
    setImages(props.gameImage.stages);
  }, [props.gameImage.stages]);
  const handleRoomCreate = () => {
    if (Images.some((e) => e.isActive === true)) {
      let data = {
        id: Images.findIndex((object) => {
          return object.isActive === true;
        }),
        game: props.gameImage.name,
      };
      data.type = props.gameImage.stages
        ? props.gameImage.stages[data.id].stage
        : 1;
      data.value = parseInt(Amount);
      data.gameType = "PlayWithFriend";
      data.gameBuild = props.gameImage.gameBuild;
      data.gameClass = props.gameImage.gameClass;
      data.isCustomBet = true;
      dispatchPopUp({ type: "open", name: "INVITE", buddyData: data });
    }
  };
  console.log("wallet balance",(walletBalance?.balance / 10 ** 18).toFixed(5))
  return (
    <>
      <Modal
        show={gameState.showModal}
        onHide={() => dispatchPopUp({ type: "close" })}
        className="gamescreen-modal"
      >
        <div className="section-onevsone">
          <div className="container">
            <div className="row matic-row">
              <div className="col-lg-6">
                <div className="matic-info">
                  <div className="matic-image">
                    <img src={require("./images/matic.png")} alt="matic" />
                  </div>
                  <div className="matic-text">
                    <h3>{(walletBalance?.balance / 10 ** 18).toFixed(5)}</h3>
                    <p>Matic Available</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 cancel-image">
                <img
                  src={require("./images/cancel-error-popup.png")}
                  onClick={() => dispatchPopUp({ type: "close" })}
                  alt="popup"
                />
              </div>
            </div>
            <div className="row head-row">
              <div className="col-lg-12">
                <h1>Select A Board</h1>
              </div>
            </div>

            <motion.div
              className="row board-row"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              {Images?.map((ele, id) => {
                // console.log(ele, "eleeleeleeleeleeleeleeleeleeleeleele");
                return (
                  <div className={`col-lg-3 gameStage${id}`} key={id}>
                    <img
                      className={ele.isActive === true ? `image-active` : ``}
                      src={ele.img}
                      onClick={() => {
                        handleGameClick(id);
                      }}
                      alt="gameStage"
                    />
                  </div>
                );
              })}
            </motion.div>
            <div className="row head-row">
              <div className="col-lg-12">
                <h1>Enter Amount</h1>
              </div>
              <div className="col-lg-8">
                <div className="form-us form-input-settings">
                  <input
                    onChange={(e) => setAmount(e.target.value)}
                    className="form-control matic-amount"
                    placeholder="Enter your Amount"
                    type = 'number'                   
                  />
                  <div className="col-lg-2">
                    <img src={require("./images/matic.png")} alt="matic" />
                  </div>
                </div>
                <div className="col-lg-12">
                  <Button
                    value="Create Room"
                    onClick={() => {
                      handleRoomCreate();
                    }}
                    disabled={Amount !== null && Amount !== "" ? false : true}
                    className = {Images?.some((e) => e?.isActive === true) && Amount !== null && Amount !== "" ? "" : "grey"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
export default OnevsOne;
